export default "__VITE_ASSET__DB_p4kHJ__";